import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import apiConfig from "../../../../apiConfig";
import { set } from "date-fns";

const SellerProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchSellerId, setSearchSellerId] = useState("");
  const [sellers, setSellers] = useState([]);

  useEffect(() => {
    fetchSellers();
  }, []);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${apiConfig.baseUrl}${apiConfig.getAllSellerProducts}`,
      );
      setProducts(res.data.products || []);
    } catch (error) {
      setProducts([]);
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSellers = async () => {
    try {
      const res = await axios.get(
        `${apiConfig.baseUrl}${apiConfig.GetAllSeller}`,
      );
      setSellers(res.data.data || []);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (productId) => {
    try {
      await axios.post(`${apiConfig.baseUrl}${apiConfig.sellerProductAccept}`, {
        productId: productId,
        action: "approve",
        remark: "dfjk",
      });
      toast.success("Product Approved Successfully");
      fetchProducts();
    } catch (error) {
      console.error(error);
    }
  };
  const handleReject = async (productId) => {
    const remark = prompt("Enter rejection remark:");
    if (!remark) {
      toast.error("Remark is required");
      return;
    }
    try {
      await axios.post(`${apiConfig.baseUrl}${apiConfig.sellerProductAccept}`, {
        productId: productId,
        action: "reject",
        remark: remark,
      });
      toast.success("Product Rejected Successfully");
      fetchProducts();
    } catch (error) {
      console.error(error);
    }
  };

  const getStatusColor = (status) => {
    if (status === "approved") return "bg-green-100 text-green-700";
    if (status === "disapproved") return "bg-red-100 text-red-700";

    return "bg-yellow-100 text-yellow-700";
  };

  const filterProducts = async (sellerUniqueId) => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${apiConfig.baseUrl}${apiConfig.filterSellerProducts}?sellerUniqueId=${sellerUniqueId}`,
      );
      setProducts(res.data.products || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (value) => {
    setSearchSellerId(value);
    if (value.trim() === "") {
      fetchProducts();
    } else {
      filterProducts(value);
    }
  };

  const handleClearSearch = () => {
    setSearchSellerId("");
    fetchProducts();
  };

  const handleRefresh = () => {
    setSearchSellerId("");
    fetchProducts();
  };

  return (
    <div className="p-4 sm:p-4 md:p-6">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-xl  font-semibold mb-4">Seller Products</h2>

        <div className="flex flex-col sm:flex-row gap-2 sm:items-center mb-4">
          <div className="flex flex-wrap items-end gap-4 mb-4">
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Seller
              </label>
              <select
                className="w-64 border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none"
                value={searchSellerId}
                onChange={(e) => handleSearchChange(e.target.value)}
              >
                <option value="">Search Sellers Product</option>

                {sellers?.map((seller) => (
                  <option key={seller._id} value={seller.sellerId}>
                    {seller.sellerId || "-"} - {seller.fullName || "-"}
                  </option>
                ))}
              </select>
            </div>
            <button
              onClick={handleClearSearch}
              className="px-4 py-2 bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-md text-sm"
            >
              Remove
            </button>
            <button
              onClick={handleRefresh}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm"
            >
              Refresh
            </button>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-md p-4 sm:p-6">
        {loading && (
          <div className="flex justify-center items-center py-20">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          </div>
        )}

        {/* No Data */}
        {!loading && products.length === 0 && (
          <div className="text-center py-20">
            <div className="text-gray-400 text-lg font-medium">
              No Products Found
            </div>
            <div className="text-gray-500 text-sm mt-2">
              Seller products will appear here
            </div>
          </div>
        )}

        {/* Desktop Table */}

        {!loading && products?.length > 0 && (
          <>
            <div className="hidden md:block overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-100">
                  <tr className="text-left text-sm">
                    <th className="p-3">Seller Name</th>
                    <th className="p-3">Title</th>
                    <th className=" p-3">Description</th>
                    <th className="p-3">Category</th>
                    <th className="p-3">Brand</th>
                    <th className="p-3">Image</th>
                    <th className="p-3">Price</th>
                    <th className="p-3">Commission</th>
                    <th className="p-3">Total</th>
                    <th className="p-3 text-center">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {products.map((item) => (
                    <tr
                      key={item._id}
                      className="border-b hover:bg-gray-50 text-sm"
                    >
                      <td className="p-3 font-medium">
                        {item.seller?.fullName || "N/A"}
                      </td>

                      <td className="p-3 font-medium">{item.title || "N/A"}</td>

                      <td className="p-3">
                        {item.description
                          ? item.description.length > 50
                            ? item.description.substring(0, 50) + "..."
                            : item.description
                          : "N/A"}
                      </td>

                      <td className="p-3">{item.category || "N/A"}</td>

                      <td className="p-3">{item.brand || "N/A"}</td>

                      <td className="">
                        {item?.productimage1 ? (
                          <div className="flex flex-wrap gap-2 max-w-[250px]">
                            {item.productimage1 && (
                              <img
                                src={`https://www.bharatcod.com/${item.productimage1}`}
                                alt="Product"
                                className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 object-cover rounded border"
                              />
                            )}

                            {item.productimage2 && (
                              <img
                                src={`https://www.bharatcod.com/${item.productimage2}`}
                                alt="Product"
                                className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 object-cover rounded border"
                              />
                            )}

                            {item.productimage3 && (
                              <img
                                src={`https://www.bharatcod.com/${item.productimage3}`}
                                alt="Product"
                                className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 object-cover rounded border"
                              />
                            )}
                          </div>
                        ) : (
                          <div className="w-12 h-12 bg-gray-200 rounded"></div>
                        )}
                      </td>

                      <td className="p-3">₹{item.sellerPrice}</td>

                      <td className="p-3">₹{item.commissionAmount || 0}</td>

                      <td className="p-3 font-semibold">
                        ₹{item.finalPrice || 0}
                      </td>

                      <td className="p-3">
                        {item?.approvalStatus == "approved" ? (
                          <div className="text-green-600 font-medium">
                            Approved
                          </div>
                        ) : (
                          <div className="flex gap-2 justify-center">
                            <button
                              onClick={() => handleApprove(item._id)}
                              className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-xs"
                            >
                              Approve
                            </button>
                            <button
                              onClick={() => handleReject(item._id)}
                              className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-xs"
                            >
                              Reject
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Mobile View */}

            <div className="md:hidden space-y-4">
              {products.map((item) => (
                <div key={item._id} className="border rounded-lg p-4 shadow-sm">
                  <div className="font-semibold">{item.title}</div>

                  <div className="text-sm text-gray-600">
                    Price: ₹{item.price}
                  </div>

                  <div className="text-sm">Total: ₹{item.totalAmount}</div>

                  <div className="mt-1">
                    <span
                      className={`px-2 py-1 text-xs rounded ${getStatusColor(item.status)}`}
                    >
                      {item.status}
                    </span>
                  </div>

                  <div className="flex gap-2 mt-3">
                    <button
                      onClick={() => handleApprove(item._id)}
                      className="flex-1 bg-green-500 text-white py-1 rounded"
                    >
                      Approve
                    </button>
                    <button
                      onClick={() => handleReject(item._id)}
                      className="flex-1 bg-red-500 text-white py-1 rounded"
                    >
                      Reject
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SellerProducts;
